import { useEffect } from "react";

import actualizarContribuyente from "../helpers/contribuyente/contribuyente/actualizar";
import mensajePreventivo from "../helpers/mensajes/mensajePreventivo";

const Confirm = ({ onRequestClose, data }) => {

    useEffect(() => {
        function onKeyDown(event) {
            // Esc
            if (event.keyCode === 27) onRequestClose();

            // Enter
            if (event.keyCode === 13) actualizar();
        }

        document.body.style.overflow = "hidden";
        document.addEventListener("keydown", onKeyDown);

        return () => {
            document.body.style.overflow = "visible";
            document.removeEventListener("keydown", onKeyDown);
        };
    });

    async function actualizar() {
        if (data.contribuyente && data.direcciones) {
            await actualizarContribuyente(data).then(() => onRequestClose())
        } else {
            mensajePreventivo("No se puede actualizar");
            onRequestClose();
        }
    }

    return (
        <div className="overlay"
            onClick={e => e.target.className === "overlay" && onRequestClose()}>

            <div className="form_login" onKeyDown={e => e.key === "Enter" && console.log(e)}>

                <div className="boxColumn">

                    <div className="boxColumn center cabecera">
                        <h2>¿Realizar los cambios?</h2>
                        <div className=" boxRow">
                            <div>
                                <button className="btn_modal aceptar" onClick={actualizar}>
                                    <span>Aceptar</span>
                                </button>
                            </div>
                            <div>
                                <button className="btn_modal cancelar" onClick={onRequestClose}>
                                    <span>Cancelar</span>
                                </button>
                            </div>
                        </div>
                    </div>

                </div>

            </div>

        </div>

    );
};

export default Confirm;
